
<ol class="value-selector">
  @for (amountValue of definedAmountsList; track amountValue; let i = $index) {
    <li>
      <input class="topup-value" name="topup-amount" type="radio" data-type="basic" #amountValueInput
        [id]="'amount-value-' + i" [value]="amountValue" (click)="setAmountValue($event, amountValue)">
        <label [for]="'amount-value-' + i" class="amount-label"> {{ amountValue + getAmountSuffix(amountValue) }}  </label>
      </li>
    }
  </ol>


  <div [hidden]="!isCustomAmountVisible">
    <div class="custom-value input-with-floating-label" [ngClass]="{'incorrect': isAmountInputInvalid()}"
      style="display: block" [formGroup]="formGroup">
      <input type="tel" id="custom-value" name="topups-amount-custom-1" formControlName="amount"
        placeholder="Wpisz kwotę doładowania ({{ amountConfig.min }} - {{ amountConfig.max }} zł)"
        amountValidator [minAmount]="amountConfig.min" [maxAmount]="amountConfig.max">
        <label for="custom-value" i18n="AmountValue">Wpisz kwotę doładowania
      ({{ amountConfig.min }}<span>-</span><span class="sr-only">do</span>{{ amountConfig.max }} zł)</label>
          <span class="error-msg-maxvalue">{{ getAmountErrorMsg() }}</span>
        </div>
      </div>
